// Koreniny Delikát brand profile. Contact/company data from koreninydelikat.sk (Kontakt page).
// TODO: analytics.
export default {
  key: 'koreniny',
  name: 'Koreniny Delikát',
  siteName: 'Koreniny Delikát',
  siteUrl: 'https://koreninydelikat.sk',
  apiUrl: 'https://api.koreninydelikat.sk/api',
  pagesPath: '/info',

  contact: {
    email: 'firmadelikat@gmail.com',
    salesEmail: 'firmadelikat@gmail.com',
    phone: '+421 948 526 862',
    openingHours: 'Po-Pia 7:30-18:00, So 9:00-15:00, Ne: zatvorené',
  },
  company: {
    name: 'Jozef Saxon JR-DELIKÁT',
    address: 'Rovňany 20, 985 24 Rovňany',
    geo: { lat: 48.4473185, lng: 19.7450312 }, // building of Rovňany 20 (OpenStreetMap), for the contact page map
    ico: '55712070',
    dic: '1129251057',
    vatNote: 'Nie sme platcami DPH',
    // Bank transfer account (same as backend brand.php)
    bank: { name: 'Jozef Saxon JR - DELIKÁT', iban: 'SK86 0900 0000 0052 4452 3548', bic: 'GIBASKBX' },
  },
  cookieConsentName: 'koreniny_cookie_consent',

  seo: {
    title: 'Koreniny Delikát',
    siteName: 'Koreniny Delikát - To najlepšie za najlepšie',
    homeDescription: 'Koreniny Delikát - To najlepšie za najlepšie. Koreniny, zmesi korenín a potreby na domácu zabíjačku od roku 1991.',
    homeKeywords: 'koreniny, korenie, zmesi korenín, domáca zabíjačka, črevá, Delikát',
    description: 'Koreniny Delikát - To najlepšie za najlepšie. Koreniny a zmesi korenín od roku 1991.',
  },

  html: {
    lang: 'sk',
    title: 'Koreniny Delikát',
    description: 'Koreniny Delikát - To najlepšie za najlepšie. Koreniny a zmesi korenín od roku 1991.',
    keywords: 'koreniny, korenie, zmesi korenín, domáca zabíjačka, Delikát',
    themeColor: '#2f4760',
    ogImage: '/og-image.png',
    // The page reaches the screen's bottom edge on iPhones (behind the home indicator), so the mobile
    // tab bar does too; it pads itself with env(safe-area-inset-bottom)
    viewportFit: 'cover',
    // Poppins for the font-poppins headings (theme.css)
    stylesheets: ['https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap'],
  },

  analytics: {
    gtagId: null,
    umamiWebsiteId: null,
  },

  sentry: {
    dsn: 'https://274d9d80f5b947329560def3a7b851a8@sentry.tx-systems.eu/2',
    org: 'txsystems-km',
    project: null,
  },

  // Sprievodca: name of its mascot (assets/sprievodca-2.png); "Rada od Gruľka" needs the genitive
  guide: {
    mascotName: 'Gruľko',
    mascotGenitive: 'Gruľka',
  },

  // Support chat launcher: routes where the bubble also says "Napíšte nám"
  chatLabelRoutes: ['home'],

  // The product page swaps sizes in place (only the URL changes) and scrolls to the top itself for
  // another product, so the router leaves the scroll position alone there
  productPageKeepsScroll: true,

  features: {
    b2b: false,
    customPricing: true, // Individuálne ceny: admin sets per customer product prices with a date range (admin only)
    contest: false,
    game: false,
    telemarketing: false,
    referrals: false,
    rewards: false,
    productSets: true,
    guide: true,
    chat: true,          // support chat: floating widget, contact page, /user/messages, admin
    chatProducts: true,  // chat topic "Spýtať sa k produktu" (pick a product, ask about it)
    avatars: true,       // profile pictures: stock ones (assets/avatars) or an upload, picked in settings
    spiceMixes: true,    // maintenance page jar game: customers name and save their mixes, admin overview
    mixBuilder: true,    // "Namiešaj si vlastný Delikát": customers order their own spice mix, admin-v2 spices and packages
    flappy: true,        // maintenance page game "Gruľko letí" with a scoreboard; admin picks the page's game (Minihra)
    pickupOnly: true,    // products flagged "Iba osobný odber": a band like Vypredané, checkout offers store pickup only
    expiring: true,      // Expirácie: admin sets pieces near their expiry date and the date, the shop shows Výpredaj until they're sold or the date passes
    maintenanceAccounts: true, // maintenance page: customers sign up / log in, the account pages (/user) stay open
    adminV2: true,       // new admin panel (right sidebar, metrics dashboard); each admin switches to it in their browser
  },
}
